<template>
  <div>
    <!-- BEGIN PAGE BAR -->
    <div class="page-bar">
      <breadcrumb :crumbs="breadcrumbArray" />
    </div>
    <!-- END PAGE BAR -->
    <!-- BEGIN PAGE TITLE-->
    <h1 class="page-title">
      Modifiers
    </h1>
    <!-- END PAGE TITLE-->
    <div class="note note-info">
      <p>Create and manage menu modifiers.</p>
    </div>
    <!-- BEGIN CREATE NEW MODIFIER CATEGORY-->
    <div
      v-if="$root.activeLocation && $root.activeLocation.id && $root.permissions['menu_manager modifiers create']"
      class="portlet box blue-hoki"
    >
      <div
        class="portlet-title bg-blue-chambray"
        @click="toggleCreateModifierPanel()"
      >
        <div class="custom tools">
          <a :class="{'expand': !createModifierCollapse, 'collapse': createModifierCollapse}" />
        </div>
        <div class="caption">
          &emsp;Create A New Modifier Category
        </div>
      </div>
      <div
        class="portlet-body"
        :class="{'display-hide': createModifierCollapse}"
      >
        <form
          role="form"
          @submit.prevent="addNewModifierCategory()"
        >
          <div class="form-body row">
            <div class="col-md-12">
              <div
                v-show="errorMessage"
                ref="errorMessage"
                class="alert alert-danger"
              >
                <button
                  class="close"
                  @click.prevent="clearError()"
                />
                <span>{{ errorMessage }}</span>
              </div>
            </div>
            <div :class="{'col-md-2' : !imageMode.newMenu, 'col-md-12' : imageMode.newMenu}">
              <resource-picker
                :image-button="true"
                :image-url="newCategory.image_url"
                class="margin-top-15"
                @open="toggleImageMode('newMenu', true)"
                @close="toggleImageMode('newMenu', false)"
                @selected="updateImage"
              />
            </div>
            <div
              v-show="!imageMode.newMenu"
              class="col-md-5"
            >
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_1"
                  v-model="newCategory.name"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.name.length}"
                >
                <label for="form_control_1">
                  Modifier Category Name
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_2"
                  v-model="newCategory.desc"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.desc.length}"
                >
                <label for="form_control_2">
                  Modifier Category Description
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_5"
                  v-model="newCategory.sku"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.sku.length}"
                >
                <label for="form_control_5">
                  Modifier Category SKU
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newCategory.min"
                  type="number"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.min}"
                >
                <label for="form_control_3">
                  Modifier Category Min
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_4"
                  v-model="newCategory.max"
                  type="number"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.max}"
                >
                <label for="form_control_4">
                  Modifier Category Max
                </label>
              </div>
            </div>
            <div
              v-show="!imageMode.newMenu"
              class="col-md-5"
            >
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_6"
                  v-model="newCategory.included"
                  type="number"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.included}"
                >
                <label for="form_control_6">
                  Modifier Category Number Free
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_7"
                  v-model="newCategory.order"
                  type="number"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.order}"
                >
                <label for="form_control_7">
                  Modifier Category Order
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_base_price"
                  v-model="newCategory.base_price"
                  type="number"
                  min="0"
                  class="form-control input-sm"
                  :class="{'edited': newCategory.base_price}"
                >
                <label for="form_control_base_price">
                  Modifier Category Base Price
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <label>Modifier Category Status:</label><br>
                <el-switch
                  v-model="newCategory.status"
                  active-color="#0c6"
                  inactive-color="#ff4949"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="Available"
                  inactive-text="Sold Out"
                />
              </div>
            </div>
          </div>
          <div
            v-show="!imageMode.newMenu"
            class="form-actions right margin-top-20"
          >
            <button
              type="submit"
              class="btn blue"
              :disabled="creating"
            >
              Create
              <i
                v-show="creating"
                class="fa fa-spinner fa-pulse fa-fw"
              />
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- END CREATE NEW MODIFIER CATEGORY-->
    <loading-screen
      :show="displayModifierData"
      :color="'#2C3E50'"
      :display="'inline'"
    />
    <div
      v-if="!$root.activeLocation.id"
      class="alert alert-info center margin-top-20"
    >
      <h4>No Store Selected</h4>
      <p>Please select a store from the location panel on the right to view its modifers</p>
    </div>
    <div v-if="$root.activeLocation && $root.activeLocation.id && !displayModifierData">
      <div
        id="categories-container"
        class="portlet light portlet-fit bordered margin-top-20"
      >
        <div class="portlet-title bg-blue-chambray">
          <div class="menu-image-main">
            <img src="../../../../public/client_logo.png">
          </div>
          <div class="caption">
            <span class="caption-subject font-default bold uppercase">
              Modifiers
            </span>
            <div class="caption-desc font-grey-cascade">
              Click on a modifer category to view its items.
            </div>
          </div>
        </div>
        <div class="portlet-body">
          <div class="row">
            <div class="col-md-12">
              <div
                v-show="listErrorMessage.length"
                ref="listErrorMessage"
                class="alert alert-danger"
              >
                <button
                  class="close"
                  @click.prevent="clearError('listErrorMessage')"
                />
                <span>{{ listErrorMessage }}</span>
              </div>
            </div>
          </div>
          <div
            v-show="$root.activeLocation.is_corporate"
            class="row"
          >
            <div class="col-xs-12">
              <el-select
                v-if="modifierTiers !== null"
                v-model="indexOfTierToDisplay"
                size="small"
                placeholder="Select Tier"
                :clearable="true"
                @change="updateList()"
              >
                <el-option
                  v-for="(tier, index) in modifierTiers"
                  :key="tier.id"
                  :label="tier.name"
                  :value="index"
                />
              </el-select>
            </div>
          </div>
          <div
            v-if="storeModifiers.length"
            class="mt-element-list margin-top-15"
          >
            <div class="mt-list-container list-news ext-1 no-border">
              <ul>
                <li
                  v-for="modifier in storeModifiers"
                  :id="'modifierCategory-' + modifier.id"
                  :key="modifier.id"
                  class="mt-list-item margin-top-15 clickable"
                  @click="viewModifierCategoryItems(modifier)"
                >
                  <div class="actions-on-top margin-bottom-15">
                    <el-tooltip
                      v-if="$root.permissions['menu_manager modifiers update']"
                      content="Edit"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="editModifierCategory(modifier, $event)"
                      >
                        <i class="fa fa-lg fa-pencil" />
                      </a>
                    </el-tooltip>
                    <el-tooltip
                      v-if="$root.permissions['menu_manager modifiers read'] && !$root.permissions['menu_manager modifiers update']"
                      content="View"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="editModifierCategory(modifier, $event)"
                      >
                        <i class="fa fa-lg fa-eye" />
                      </a>
                    </el-tooltip>
                    <el-tooltip
                      v-if="$root.permissions['menu_manager modifiers update items']"
                      content="Apply to items"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="displayMenuTreeModal(modifier, $event)"
                      >
                        <i class="fa fa-link" />
                      </a>
                    </el-tooltip>
                    <el-tooltip
                      v-if="$root.permissions['stores copy modifier modifier_to_multiple_location']"
                      content="Copy to stores"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="displayCopyToLocationsModal(modifier, $event)"
                      >
                        <i class="fa fa-lg fa-copy" />
                      </a>
                    </el-tooltip>
                    <el-tooltip
                      v-if="$root.permissions['stores add item_to_multiple_locations']"
                      content="Apply to items at stores"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="displayApplyToItemsAtLocationsModal(modifier, $event)"
                      >
                        <i class="fa fa-lg fa-plus" />
                      </a>
                    </el-tooltip>
                    <el-tooltip
                      v-if="$root.permissions['menu_manager modifiers delete']"
                      content="Delete"
                      effect="light"
                      placement="top"
                    >
                      <a
                        class="btn btn-circle btn-icon-only btn-default"
                        @click="deleteModifierCategory(modifier, $event)"
                      >
                        <i class="fa fa-lg fa-trash" />
                      </a>
                    </el-tooltip>
                  </div>
                  <div class="list-icon-container">
                    <a>
                      <i class="fa fa-angle-right" />
                    </a>
                  </div>
                  <div class="list-thumb">
                    <a v-if="modifier.image_url.length">
                      <img
                        alt=""
                        :src="modifier.image_url"
                      >
                    </a>
                    <a v-else>
                      <img src="../../../assets/img/app/login/bg1.jpg">
                    </a>
                  </div>
                  <div class="list-datetime bold font-red">
                    <span>{{ modifier.name }}</span>
                  </div>
                  <div class="list-item-content height-mod">
                    <div class="col-md-2">
                      <strong>Min: </strong>
                      <span>{{ modifier.min }}</span>
                    </div>
                    <div class="col-md-2">
                      <strong>Max: </strong>
                      <span>{{ modifier.max }}</span>
                    </div>
                    <div class="col-md-4">
                      <strong>Status: </strong>
                      <span v-if="modifier.status == 1">
                        Available
                      </span>
                      <span v-if="modifier.status == 0">
                        Sold Out
                      </span>
                    </div>
                    <div class="col-md-4">
                      <strong>SKU: </strong>
                      <span>{{ modifier.sku }}</span>
                    </div>
                    <div class="col-md-12">
                      <strong>Description: </strong>
                      <span>{{ modifier.desc }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="!storeModifiers.length && !displayModifierData"
            class="margin-top-20"
          >
            <no-results
              :show="!storeModifiers.length"
              :type="'modifier categories'"
              :custom="true"
              :text="customText"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$root.activeLocation.id && !displayModifierData"
      class="margin-top-20"
    >
      <no-results :type="'modifier categories'" />
    </div>
    <edit-modifier-category
      v-if="editCategoryModalActive"
      @updateModifierCategory="updateModifierCategory"
      @deactivateEditCategoryModal="closeEditCategoryModal"
    />
    <delete-modifier-category
      v-if="deleteCategoryModalActive"
      :passed-modifier-category-id="passedModifierCategoryId"
      @closeDeleteModifierCategoryModal="closeDeleteModifierCategoryModal"
      @deleteModifierCategoryAndCloseModal="deleteModifierCategoryAndCloseModal"
    />
    <menu-tree
      v-if="showMenuTreeModal"
      :selected-object="selectedModifier"
      :header-text="headerText"
      :update-type="'modifier'"
      @closeMenuTreeModal="closeMenuTreeModal"
    />
    <apply-modifier-to-items-at-locations
      v-if="showModifierToApplyToItemsAtLocationsModal"
      :modifier="modifierToApplyToItemsAtLocations"
      @closeApplyModifierToItemsAtLocations="closeApplyModifierToItemsAtLocationsModal"
      @applyModifierToItemsAtLocationsSuccess="showApplyModifierToItemsAtLocationsSuccess"
    />
    <copy-modifier-to-locations
      v-if="showCopyModifierToLocationsModal"
      :modifier="modifierToCopyToLocations"
      @closeCopyModifierToLocations="closeCopyModifierToLocationsModal"
      @copyModifierToLocationsSuccess="showCopyModifierToLocationsSuccess"
    />
  </div>
</template>

<script>
import Breadcrumb from '../../modules/Breadcrumb'
import NoResults from '../../modules/NoResults'
import Modal from '../../modules/Modal'
import LoadingScreen from '../../modules/LoadingScreen'
import EditModifierCategory from './Modifiers/EditModifierCategory'
import DeleteModifierCategory from './Modifiers/DeleteModifierCategory'
import ModifiersFunctions from '../../../controllers/Modifiers'
import MenuTree from '../../modules/MenuTree'
import ResourcePicker from '../../modules/ResourcePicker'
import ApplyModifierToItemsAtLocations from '@/components/app/MenuManager/Modifiers/ApplyModifierToItemsAtLocations'
import CopyModifierToLocations from '@/components/app/MenuManager/Modifiers/CopyModifierToLocations'
import ajaxErrorHandler from '@/controllers/ErrorController'
import ModifierTiersFunctions from '@/controllers/ModifierTiers'
import { isNonNegativeInteger, isNonNegativeNumber } from '@/controllers/utils'

export default {
  components: {
    Breadcrumb,
    Modal,
    LoadingScreen,
    EditModifierCategory,
    DeleteModifierCategory,
    NoResults,
    MenuTree,
    ResourcePicker,
    ApplyModifierToItemsAtLocations,
    CopyModifierToLocations
  },
  data () {
    return {
      breadcrumbArray: [
        { name: 'Menu Manager', link: false },
        { name: 'Modifiers', link: false }
      ],
      displayModifierData: false,
      editCategoryModalActive: false,
      deleteCategoryModalActive: false,
      storeModifiers: [],
      newCategory: {
        name: '',
        desc: '',
        sku: '',
        image_url: '',
        user_id: this.$root.createdBy,
        status: 1,
        min: '',
        max: '',
        included: '',
        order: '',
        base_price: ''
      },
      errorMessage: '',
      createModifierCollapse: true,
      showMenuTreeModal: false,
      selectedModifier: {},
      passedModifierCategoryId: 0,
      headerText: '',
      imageMode: {
        newMenu: false
      },
      modifierToApplyToItemsAtLocations: {},
      showModifierToApplyToItemsAtLocationsModal: false,
      modifierTiers: null,
      listErrorMessage: '',
      indexOfTierToDisplay: null,
      showCopyModifierToLocationsModal: false,
      modifierToCopyToLocations: {},
      creating: false
    }
  },
  computed: {
    customText () {
      if (this.indexOfTierToDisplay === '') {
        return 'This location does not have any Modifier Categories.'
      } else {
        return 'This tier does not have any Modifier Categories.'
      }
    }
  },
  watch: {
    '$root.activeLocation' () {
      this.getStoreModifiers()
      this.indexOfTierToDisplay = null
      this.getModifierTiers()
    }
  },
  mounted () {
    if (this.$root.activeLocation && this.$root.activeLocation.id) {
      this.getStoreModifiers()
    }
    this.getModifierTiers()
  },
  methods: {
    /**
     * To update the modifiers shown in the list based on user's filter selection
     * @function
     * @returns {undefined}
     */
    updateList () {
      if (this.indexOfTierToDisplay !== '') {
        this.getModifierTierDetails()
      } else {
        this.getStoreModifiers()
      }
    },
    /**
     * To fetch a list of modifiers for a tier
     * @function
     * @returns {object} - A network call promise
     */
    getModifierTierDetails () {
      let modifiersVue = this
      const tier = modifiersVue.modifierTiers[modifiersVue.indexOfTierToDisplay]
      return ModifierTiersFunctions.getModifierTierDetails(tier)
        .then(response => {
          modifiersVue.storeModifiers = response.payload
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorName: 'listErrorMessage',
            errorText: "We couldn't fetch modifiers for this tier",
            vue: modifiersVue
          })
        })
    },
    /**
     * To fetch a list of Modifier Tiers
     * @function
     * @returns {object} Network call promise
     */
    getModifierTiers () {
      let modifiersVue = this
      return ModifierTiersFunctions.getModifierTiers()
        .then(response => {
          modifiersVue.modifierTiers = response.payload
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorName: 'listErrorMessage',
            errorText: "We couldn't fetch modifier tiers",
            vue: modifiersVue
          })
        })
    },
    /**
     * To display the modal to apply a modifier to selected items at selected locations.
     * @function
     * @param {object} modifier - The selected modifier category.
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    displayApplyToItemsAtLocationsModal (modifier, event) {
      event.stopPropagation()
      this.modifierToApplyToItemsAtLocations = modifier
      this.showModifierToApplyToItemsAtLocationsModal = true
    },
    /**
     * To display the modal to copy a modifier to selected locations.
     * @function
     * @param {object} modifier - The selected modifier category.
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    displayCopyToLocationsModal (modifier, event) {
      event.stopPropagation()
      this.modifierToCopyToLocations = modifier
      this.showCopyModifierToLocationsModal = true
    },
    /**
     * To close the modal to copy a modifier to selected locations.
     * @function
     * @returns {undefined}
     */
    closeCopyModifierToLocationsModal () {
      this.showCopyModifierToLocationsModal = false
    },
    /**
     * To close the modal to apply a modifier to selected items at selected locations.
     * @function
     * @returns {undefined}
     */
    closeApplyModifierToItemsAtLocationsModal () {
      this.showModifierToApplyToItemsAtLocationsModal = false
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showApplyModifierToItemsAtLocationsSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The Modifiers have been saved'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The Modifiers have been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showCopyModifierToLocationsSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The Modifier has been created'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The Modifier has been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To toggle between the open and closed state of the resource picker
     * @function
     * @param {string} object - The name of the object the image is for
     * @param {object} value - The open / closed value of the picker
     * @returns {undefined}
     */
    toggleImageMode (object, value) {
      this.imageMode[object] = value
    },
    /**
     * To set the image to be same as the one emitted by the gallery modal.
     * @function
     * @param {object} val - The emitted image object.
     * @returns {undefined}
     */
    updateImage (val) {
      this.newCategory.image_url = val.image_url
    },
    /**
     * To display the modal to apply a modifier to multiple items.
     * @function
     * @param {object} modifier - The selected modifier category
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    displayMenuTreeModal (modifier, event) {
      event.stopPropagation()
      this.selectedModifier = modifier
      this.headerText = "Modifier '" + this.selectedModifier.name + "'"
      this.showMenuTreeModal = true
    },
    /**
     * To close the menu tree modal.
     * @function
     * @returns {undefined}
     */
    closeMenuTreeModal () {
      this.showMenuTreeModal = false
    },
    /**
     * To get a list of modifier categories for the current store.
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getStoreModifiers () {
      this.displayModifierData = true
      var menusVue = this
      menusVue.storeModifiers = []
      return ModifiersFunctions.getStoreModifiers(
        menusVue.$root.activeLocation.id
      )
        .then(response => {
          if (response.code === 200 && response.status === 'ok') {
            menusVue.displayModifierData = false
            menusVue.storeModifiers = response.payload
          } else {
            menusVue.displayModifierData = false
          }
        })
        .catch(reason => {
          menusVue.displayModifierData = false
          ajaxErrorHandler({
            reason,
            errorName: 'listErrorMessage',
            errorText: 'We could not fetch modifiers',
            vue: menusVue
          })
        })
    },
    /**
     * To display the modal to edit a modifier category.
     * @function
     * @param {object} modifier - The selected modifier category
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    editModifierCategory (modifier, event) {
      event.stopPropagation()
      this.editCategoryModalActive = true
      this.$router.push(
        '/app/menu_manager/modifiers/edit_category/' + modifier.id
      )
    },
    /**
     * To display the modal to delete a modifier category.
     * @function
     * @param {object} modifier - The selected modifier category
     * @param {object} event - The click event that prompted this function.
     * @returns {undefined}
     */
    deleteModifierCategory (modifier, event) {
      event.stopPropagation()
      this.deleteCategoryModalActive = true
      this.passedModifierCategoryId = modifier.id
    },
    /**
     * To update the modifier category list and close the edit modal
     * @function
     * @returns {undefined}
     */
    updateModifierCategory () {
      this.getStoreModifiers()
      this.editCategoryModalActive = false
    },
    /**
     * To check if the modifier category data is valid before submitting to the backend.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    validateModifierCategoryData () {
      var addModifierCategoryVue = this
      return new Promise(function (resolve, reject) {
        if (!addModifierCategoryVue.newCategory.image_url.length) {
          reject('Modifier Category image cannot be blank')
        } else if (!addModifierCategoryVue.newCategory.name.length) {
          reject('Modifier Category Name cannot be blank')
        } else if (!addModifierCategoryVue.newCategory.desc.length) {
          reject('Modifier Category Description cannot be blank')
        } else if (!addModifierCategoryVue.newCategory.sku.length) {
          reject('Modifier Category SKU cannot be blank')
        } else if (!isNonNegativeNumber(addModifierCategoryVue.newCategory.min)) {
          reject('Modifier Category Min must be zero or more')
        } else if (!isNonNegativeNumber(addModifierCategoryVue.newCategory.max)) {
          reject('Modifier Category Max must be zero or more')
        } else if (
          Number(addModifierCategoryVue.newCategory.min) > Number(addModifierCategoryVue.newCategory.max)
        ) {
          reject('Modifier Category Min cannot be larger than Max')
        } else if (!isNonNegativeNumber(addModifierCategoryVue.newCategory.included)) {
          reject('Modifier Category Number Free must be zero or more')
        } else if (!isNonNegativeNumber(addModifierCategoryVue.newCategory.order)) {
          reject('Modifier Category Order must be zero or more')
        } else if (!isNonNegativeNumber(addModifierCategoryVue.newCategory.base_price)) {
          reject('Modifier Category Base Price must be zero or more')
        }
        resolve('Hurray')
      })
    },
    /**
     * To clear the new menu form.
     * @function
     * @returns {undefined}
     */
    clearNewCategory () {
      this.newCategory = {
        name: '',
        desc: '',
        sku: '',
        image_url: '',
        user_id: this.$root.createdBy,
        status: 1,
        min: '',
        max: '',
        included: '',
        order: '',
        base_price: ''
      }
    },
    /**
     * To add the new modifier category and close the modal and redirect to the modifiers page.
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    addNewModifierCategory () {
      var addModifierCategoryVue = this
      addModifierCategoryVue.clearError()

      return addModifierCategoryVue
        .validateModifierCategoryData()
        .then(response => {
          addModifierCategoryVue.creating = true
          addModifierCategoryVue.newCategory.location_id =
            addModifierCategoryVue.$root.activeLocation.id
          ModifiersFunctions.addNewModifierCategory(
            addModifierCategoryVue.newCategory,
            addModifierCategoryVue.$root.appId,
            addModifierCategoryVue.$root.appSecret,
            addModifierCategoryVue.$root.userToken
          )
            .then(response => {
              if (response.code === 200 && response.status === 'ok') {
                addModifierCategoryVue.newCategory.id = response.payload.id
                addModifierCategoryVue.getStoreModifiers()
                addModifierCategoryVue.showAlert(response.payload)
                addModifierCategoryVue.clearNewCategory()
              } else {
                addModifierCategoryVue.errorMessage = response.message
              }
            })
            .catch(reason => {
              ajaxErrorHandler({
                reason,
                errorName: 'errorMessage',
                errorText: 'We could not create the modifier category',
                vue: addModifierCategoryVue
              })
            })
            .finally(() => {
              addModifierCategoryVue.creating = false
            })
        })
        .catch(reason => {
          // If validation fails then display the error message
          addModifierCategoryVue.errorMessage = reason
          window.scrollTo(0, 0)
          throw reason
        })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showAlert (payload = {}) {
      let title = 'Success'
      let text = 'The Modifier Category has been created'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The Modifier Category has been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To close the modal to edit a modifier category.
     * @function
     * @returns {undefined}
     */
    closeEditCategoryModal () {
      this.editCategoryModalActive = false
    },
    /**
     * To close the modal to delete a modifier category.
     * @function
     * @returns {undefined}
     */
    closeDeleteModifierCategoryModal () {
      this.deleteCategoryModalActive = false
    },
    /**
     * To close the modal to delete a modifier category.
     * @function
     * @returns {undefined}
     */
    deleteModifierCategoryAndCloseModal () {
      this.deleteCategoryModalActive = false
      this.getStoreModifiers()
    },
    /**
     * To route to the modifier items page.
     * @function
     * @param {object} modifier - The selected modifier category
     * @returns {undefined}
     */
    viewModifierCategoryItems (modifier) {
      this.$router.push('/app/menu_manager/modifier_items/' + modifier.id)
    },
    /**
     * To clear the current error.
     * @function
     * @param {string} name - Name of the error variable
     * @returns {undefined}
     */
    clearError (name = 'errorMessage') {
      this[name] = ''
    },
    /**
     * To toggle the create menu panel, initially set to opened
     * @function
     * @returns {undefined}
     */
    toggleCreateModifierPanel () {
      this.createModifierCollapse = !this.createModifierCollapse
    }
  }
}
</script>

<style scoped>
.actions-on-top {
  margin-top: -5px;
}
</style>
